import KSelect from "./KSelect";
import {
	VCheckbox,
	VDivider,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default {
	name: "KSelectWithAll",

	extends: KSelect,

	props: {
		items: {
			default: () => ( [] ),
			type: Array
		},

		multiple: {
			default: true,
			type: Boolean
		},

		returnObject: Boolean,

		selectAllText: {
			default: "Select All",
			type: String
		},

		value: {
			default: () => ( [] ),
			type: Array
		}
	},

	computed: {
		someSelected() {
			return this.value && this.value.length > 0;
		},

		allSelected() {
			return this.value && this.items && this.value.length === this.items.length;
		}
	},

	methods: {
		toggleAll() {
			let items = [];

			if ( !this.allSelected ) {
				items = this.items.map( item => (
					this.returnObject
						? item
						: item[this.itemValue]
				) );
			}

			this.internalValue = items;

			this.$emit( "change", items );
		},

		genValidatableField( props ) {
			return <KSelect
				attrs={{
					...this.$props,
					errorMessages: props.errors
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}

				<template slot="prepend-item">
					<VListItem
						ripple
						onClick={this.toggleAll}
					>
						<VListItemAction>
							<VCheckbox
								color="accent"
								inputValue={this.allSelected}
								indeterminate={this.someSelected && !this.allSelected}
							></VCheckbox>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>{this.selectAllText}</VListItemTitle>
						</VListItemContent>
					</VListItem>

					<VDivider class="mt-2"></VDivider>
				</template>
			</KSelect>;
		}
	}
};
